import React from 'react'
import PropTypes from 'prop-types'

import { AstuteProvider } from './context'
import { Views } from './Views'

export const Astute = (props) => (
  <AstuteProvider {...props}>
    <Views />
  </AstuteProvider>
)

Astute.propTypes = {
  astuteRequest: PropTypes.object,
  lastServiceRequest: PropTypes.object,
  authenticityToken: PropTypes.string,
  holdings: PropTypes.object,
  client: PropTypes.object.isRequired,
  lastUpdated: PropTypes.string,
  tenantSlug: PropTypes.string.isRequired,
  paths: PropTypes.exact({
    newAstuteRequestPath: PropTypes.string.isRequired,
    clientDashboardPath: PropTypes.string.isRequired,
    // TODO: refreshPath seems currently unused
    refreshPath: PropTypes.string.isRequired,
    retryPath: PropTypes.string.isRequired,
    importAssetsPath: PropTypes.string.isRequired
  }).isRequired,
}
